import React from 'react';

const TONLAGEN = [
  { wert: 'klassisch', name: 'Klassisch', beschreibung: 'Traditionell formell. Bewährt, sicher, professionell.' },
  { wert: 'modern', name: 'Modern & Direkt', beschreibung: 'Klar und auf den Punkt. Ohne Füllwörter und Floskeln.' },
  { wert: 'selbstbewusst', name: 'Selbstbewusst', beschreibung: 'Bestimmt und überzeugend. Stärken werden aktiv betont.' },
  { wert: 'zurueckhaltend', name: 'Zurückhaltend', beschreibung: 'Bescheiden und kollegial. Betont Lernbereitschaft.' },
];

function TonlageTool({ tonlage, onChange }) {
  return (
    <div style={{ paddingTop: 16 }}>
      <h4 style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#666', marginBottom: 12 }}>Tonlage</h4>
      <div className="beschmuecken-optionen">
        {TONLAGEN.map((t) => (
          <button
            key={t.wert}
            className={`beschmuecken-btn ${tonlage === t.wert ? 'aktiv' : ''}`}
            onClick={() => onChange(t.wert)}
          >
            <span className="beschmuecken-name">{t.name}</span>
            <span className="beschmuecken-beschr">{t.beschreibung}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default TonlageTool;
